import { NB } from '@cerebral-inc/ui';
import BlurryLoadingImage from 'components/shared/blur-image/BlurryLoadingImage';
import { getStaticFilePath } from 'components/shared/utils';
import People from './images/avatar.png';
import PeoplePreview from './images/people.png';
import Star from './images/star.svg';

const { Flex, Text } = NB;

export const TrustPilot = () => {
  return (
    <Flex flexDir="row" flexWrap="wrap" py="16px" alignItems="center">
      <BlurryLoadingImage
        preview={PeoplePreview}
        image={People}
        alt="people"
        width={72}
        height={32}
      />
      <Text
        color="c_grey.900"
        fontSize="12px"
        fontWeight="600"
        pl="16px"
        pr="13px"
      >
        Great
      </Text>
      <Text color="c_grey.900" fontSize="12px" fontWeight="400">
        <Text fontWeight="600">4.0</Text> out of 5
      </Text>
      <Flex alignItems="center" pl="13px" flexDir="row">
        <img
          src={getStaticFilePath(Star)}
          alt="trustpilot-star"
          width="14px"
          height="13.25px"
        />
        <Text color="c_grey.900" fontSize="12px" fontWeight="600" pl="4px">
          Trustpilot
        </Text>
      </Flex>
    </Flex>
  );
};
